import styled from 'styled-components'

export const AvatarSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const CardsRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: stretch;
`
